import { render } from "./backgroundMedia.vue?vue&type=template&id=ee6eab38&scoped=true"
import script from "./backgroundMedia.vue?vue&type=script&lang=js"
export * from "./backgroundMedia.vue?vue&type=script&lang=js"

import "./backgroundMedia.vue?vue&type=style&index=0&id=ee6eab38&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee6eab38"]])

export default __exports__